jQuery(function($) {
    $( document ).ready(function() {

        cityContent();
        hamletServices();

        function cityContent() {
            
            var cityContent = document.querySelector('.city-content');

            if(cityContent) {

                // SLIDER NO MAP
                var sliderWrapper = cityContent.querySelector('.slider-wrapper');
                let openIcon = sliderWrapper.querySelector('#open-icon');
                let closeIcon = sliderWrapper.querySelector('#close-icon');
                let dropdown = sliderWrapper.querySelector('.dropdown-content');

                openIcon.addEventListener('click' , function() {

                    openIcon.style.display = "none";
                    closeIcon.style.display = "block";
                    dropdown.classList.add('open');

                })
                closeIcon.addEventListener('click' , function() {
                    openIcon.style.display = "block";
                    closeIcon.style.display = "none";
                    dropdown.classList.remove('open');
                })

                // SLIDER WITH MAP
                var sliderWrapperMap = cityContent.querySelector('.slider-wrapper-map');
                let openIconMap = sliderWrapperMap.querySelector('#open-icon');
                let closeIconMap = sliderWrapperMap.querySelector('#close-icon');
                let dropdownMap = sliderWrapperMap.querySelector('.dropdown-content');

                openIconMap.addEventListener('click' , function() {

                    openIconMap.style.display = "none";
                    closeIconMap.style.display = "block";
                    dropdownMap.classList.add('open');

                })
                closeIconMap.addEventListener('click' , function() {
                    openIconMap.style.display = "block";
                    closeIconMap.style.display = "none";
                    dropdownMap.classList.remove('open');
                })

                
                var sliderWrapperMap = cityContent.querySelector('.slider-wrapper-map');
                var mapElement = sliderWrapperMap.querySelector('#map');

                if(mapElement) {
                    let lng = mapElement.getAttribute("data-lng");
                    let lat = mapElement.getAttribute("data-lat");
                    mapboxgl.accessToken = 'pk.eyJ1IjoiZWxpYXNiYXNlIiwiYSI6ImNsdDQ2d3l4cDFlajYya3J6eHo3MGhvMzIifQ.Yiha2ZjhBdJdIlScSC7T2Q';
                    const map = new mapboxgl.Map({
                    container: 'map', // container ID
                    center: [lng, lat], // starting position [lng, lat]
                    zoom: 15, // starting zoom
                    style: 'mapbox://styles/eliasbase/clt457jca00pg01qw69xmahhv'
                    });
                    const marker = document.createElement('div')
                    marker.className = 'mapboxMarker'
                    const mapboxMarker = new mapboxgl.Marker(marker)
                        .setLngLat([lng, lat])
                        .addTo(map)
                }
            
            }


        }
       
  
        function hamletServices() {
            var servicesGrid = document.querySelector('.location .services-grid');
  
            if(servicesGrid) {
                var services = servicesGrid.querySelectorAll('.service');
                var counter = 0;
  
                services.forEach(function(service) {

                    counter++;
  
                    let openIcon = service.querySelector('#open-icon');
                    let closeIcon = service.querySelector('#close-icon');
    
                    openIcon.addEventListener('click' , function() {
                        
                        hamletServicesClose(services);
                        hamletServiceOpen(service , openIcon , closeIcon);
                        hamletServicesStyles(services);
    
                    })
                
                    closeIcon.addEventListener('click' , function() {
                        hamletServiceClose(service , openIcon , closeIcon);
                        hamletServicesResetStyles(services);
                    })

                    if(window.innerWidth >= 1024) {
                        if (counter % 3 === 0) {
                            addDropdownContent(service); 
                        }
                    } else if (window.innerWidth >= 767 && window.innerWidth < 1024) {
                        if (counter % 2 === 0) {
                            addDropdownContent(service); 
                        }
                    } else if (window.innerWidth < 767) {
                        if (counter % 1 === 0) {
                            addDropdownContent(service); 
                        }
                    }

                    addLastDropdown();

                   
              })
            }
        }

        function addDropdownContent(service) {

            var dropdownContent = document.createElement('div');
            dropdownContent.classList.add('dropdown-content');
            dropdownContent.innerHTML = '<p></p>'; 
        
            service.parentNode.insertBefore(dropdownContent, service.nextSibling);
        }
        
  
        // OPEN ONE SERVICE
        function hamletServiceOpen(service, openIcon, closeIcon) {
            
            service.classList.add('active');
            openIcon.style.display = "none";
            closeIcon.style.display = "block";

            let content = service.querySelector('.contenu').textContent;
            let dropdown = findDropdown(service);
        
            if (dropdown) {
                let dropdownContent = dropdown.querySelector('p');
                dropdownContent.textContent = content;
                dropdown.classList.add('open');
            }
    
        }
    
        // CLOSE ONE SERVICE
        function hamletServiceClose(service , openIcon , closeIcon) {
    
            service.classList.remove('active');
            openIcon.style.display = "block";
            closeIcon.style.display = "none";
            
            var dropdownContent = findDropdown(service);

            if (dropdownContent) {
                dropdownContent.classList.remove('open');
            }
        }
    
        // CLOSE ALL SERVICES
        function hamletServicesClose(services) {
            services.forEach(function(service) {
                let openIcon = service.querySelector('#open-icon');
                let closeIcon = service.querySelector('#close-icon');
                openIcon.style.display = "block";
                closeIcon.style.display = "none";
                service.classList.remove('active');
            })

            let dropdowns = document.querySelectorAll('.services-grid .dropdown-content');
            dropdowns.forEach(function(dropdown) {
                dropdown.classList.remove('open');
            })
            hamletServicesStyles(services);
        }
    
        // UPDATE Styles ON SERVICES 
        function hamletServicesStyles(services) {
    
            hamletServicesResetStyles(services);
    
            services.forEach(function(service) {
                let titleWrapper = service.querySelector('.title-wrapper');
                let title = titleWrapper.querySelector('h4');
                let openIcon = titleWrapper.querySelector('#open-icon');
                let img = service.querySelector('img');

                if(!service.classList.contains('active')) {
                    title.style.color = "grey";
                    openIcon.style.color = "grey";

                    if(img) {
                        img.style.filter = "blur(10px)";
                        title.style.filter = "blur(10px)";
                        openIcon.style.filter = "blur(10px)";
                    }
                }

            })
        }
  
        // RESET ALL SERVICES COLOR
        function hamletServicesResetStyles(services) {
    
            services.forEach(function(service) {
                let titleWrapper = service.querySelector('.title-wrapper');
                let title = titleWrapper.querySelector('h4');
                let openIcon = titleWrapper.querySelector('#open-icon');
                let img = service.querySelector('img');

                // RESET COLORS
                title.style.color = "initial";
                openIcon.style.color = "initial";


                if(img) {
                    title.style.color = "white";
                    openIcon.style.color = "white";
                    img.style.filter = "blur(0px)";
                    title.style.filter = "blur(0px)";
                    openIcon.style.filter = "blur(0px)";
                }
                
            })
        }

        function findDropdown(service) {
            var nextSibling = service.nextSibling;
            while (nextSibling) {
                if (nextSibling.classList && nextSibling.classList.contains('dropdown-content')) {
                    return nextSibling;
                }
                nextSibling = nextSibling.nextSibling;
            }
            return null;
        }

        function addLastDropdown() {
            var servicesGridChilds = document.querySelectorAll('.location .services-grid > *');
            var length = servicesGridChilds.length
            var lastChild = servicesGridChilds[length - 1];
            if(lastChild.classList.contains('service')) {
                addDropdownContent(lastChild);
            }
        }
    });
});
